import styled from 'styled-components';
import {
  lighten,
} from 'polished';

import {
  Flex,
} from 'web-styled';

export const Body = styled(Flex).attrs({
  column: true,
  spacing: 5,
  padding: '10px 15px',
})`
  border-radius: 15px;
  background-color: #f9f9f9;
  overflow: hidden;

  img {
    max-width: 100%;
  }

  ${props => (props.self ? `
    background-color: ${lighten(0.5, props.theme.colors.primary)};
    border-bottom-right-radius: 0;
  ` : `
    background-color: #f9f9f9;
    border-bottom-left-radius: 0;
  `)}
`;

export const Workout = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
})`
  color: #fff;
  width: calc(100% + 30px);
  padding: 5px 15px;
  margin: 0 -15px -10px -15px;
  background-color: ${props => props.theme.colors.primary};
`;
